import { Injectable } from '@angular/core';
import { Country } from '../../classes/country';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';
import { Auth } from '../auth.service';

@Injectable()
export class CountryService extends UserService {

  constructor(
    protected requestService: RequestService,
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'country';
  };

  protected getOneUserUrl(): string {

    return 'country';
  };

  protected parseObject(obj: any): Country {

    return obj as Country;
  };

  protected parseArray(objs: any): Country[] {

    return objs as Country[];
  };

  public getAll(): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get'
    }, '/country?sort=name ASC')
    .then((response: any) => {
      return response._body;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/country/country.service.ts